import { useEffect, useState } from 'react'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text-v1'
import { Badge } from '@wartek-id/badge'

import type { HTMLProps } from 'react'

interface PropsCustomFileUpload
  extends Omit<HTMLProps<HTMLDivElement>, 'value'> {
  title?: string
  displayFileName?: string
  subtitle?: string
  extraDesc?: string
  exampleFilePath?: string
  placeholder?: string
  notes?: string
  value?: File
  isLoading?: boolean
  onClick?: () => any
  onClickDelete?: () => any
}

const CustomFileUpload = ({
  title,
  displayFileName,
  subtitle,
  extraDesc,
  exampleFilePath,
  placeholder = 'Pilih dokumen',
  notes,
  value,
  isLoading = false,
  onClick = () => undefined,
  onClickDelete = () => undefined,
  ...otherProps
}: PropsCustomFileUpload) => {
  const [file, setFile] = useState<File>(value)

  useEffect(() => {
    setFile(value)
  }, [value])

  return (
    <div {...otherProps}>
      <div className="flex justify-between items-start">
        <Text variant="body">{title}</Text>
        <Badge variant="warning" className="!shrink-0">
          Perlu diperbaiki
        </Badge>
      </div>

      <Text variant="helper" color="subdued" className="mt-3">
        <strong>Catatan:</strong> <br />
        {notes}
      </Text>

      <Text variant="helper" color="subdued" className="mt-3">
        {subtitle}
      </Text>

      {!!extraDesc && (
        <Text variant="helper" color="subdued">
          {extraDesc}
        </Text>
      )}

      {exampleFilePath && (
        <Link href={exampleFilePath} passHref>
          <a>
            <Text variant="helper" className="!text-blue-60">
              Lihat contoh dokumen
            </Text>
          </a>
        </Link>
      )}

      {file ? (
        <div className="rounded w-full mt-2 p-3 border border-black">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center" onClick={onClick}>
              <Icon>text_snippet</Icon>
              <Text className="ml-2" variant="body">
                {displayFileName ?? file.name}
              </Text>
            </div>
            {isLoading ? (
              <Spinner size="sm" />
            ) : (
              <Button
                variant="ghost"
                size="sm"
                color="red"
                onClick={onClickDelete}
              >
                Hapus
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div
          className="rounded w-full mt-2 border-dashed p-3 border-2 border-subdued"
          onClick={onClick}
        >
          <div className="flex flex-row items-center">
            <Icon className="-rotate-45">attachment</Icon>
            <Text color="subdued" className="ml-2 italic">
              {placeholder}
            </Text>
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomFileUpload
